import React from "react";
import SiteLayout from "@/components/SiteLayout";
import Contact from "@/sections/Contact";

const ContactPage = () => (
  <SiteLayout>
    <Contact />
  </SiteLayout>
);

export default ContactPage;
